import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Token, UserDetails } from "../../app.model";
import { CacheService } from "../../cache.service";
import { NS_AccountCommonDialog, NS_Enums,NS_SubscriptionPlanCard, NS_SubscriptionService, customerSupportLink } from "../../shared/namespaces";
import { filter, forEach, get, isUndefined, first, find, isNil, includes, isEqual, isEmpty, toLower, head, orderBy, compact, castArray, difference, findIndex, some, intersection, size } from "lodash-es";
import { SubscriptionDataService } from "./subscription-data.service";
import { Router } from "@angular/router";
import { AppService } from "src/app/app.service";
import { AccountCommonDialogComponent } from "../components/subscription/child-components/account-common-dialog/account-common-dialog.component";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { BillingCycleChangeComponent } from "src/app/account/components/subscription/child-components/billing-cycle-change-popup/billing-cycle-change-popup.component";
import { environment } from "src/environments/environment";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { BehaviorSubject, Observable, Subject, of} from "rxjs";
import { catchError, delay, map, switchMap, take } from "rxjs/operators";
import { formatDateCustom, getBillingCycle, getFromDescription, isJsonValid, operators } from "src/app/shared/helpers/helpers";
import { CommonDialogComponent } from "src/app/common-dialog/common-dialog.component";
import { ActiveAddonAccess, CompanySubscription, UpdateBillingAddress } from "../models/subscription-models";
import { TrialPlanService } from "./../../services/trialplan/trialplan.service";
import { AuthService } from "src/app/auth/auth.service";
import { getRolesFromToken } from "src/app/shared/helpers/jwt.helper";
import { jsonDSL } from "src/app/connector-studio/utilities/jsonLogic";
import { NoopScrollStrategy } from '@angular/cdk/overlay';

@Injectable({
    providedIn: "root",
})
export class SubscriptionBusinessService {   
    constructor(private cacheService: CacheService,private trialPlanService: TrialPlanService ,private router: Router,private subscriptionDataService: SubscriptionDataService, private appService: AppService,
       private dialog: MatDialog, private snackBar: MatSnackBar, private authService: AuthService, private http: HttpClient ) {
        this.authToken = this.authService.authToken
        if(this.authToken) {
            this.userRoles = getRolesFromToken(this.authToken) 
        }
     }
     baseWord = this.appService.getBaseWord();
    checkoutDataSubscription = {"checkoutType":0, "subscriptionPlanId":1,"userId":558, "chargebeeSubscriptionId": "", "companyId": 0}
    saras_auth_key = this.cacheService.getObject<Token>(NS_Enums.cacheKeysEnum.saras_auth_key);
    uncommonBaseWord: string = this.appService.getUncommonBaseWord();
    currentlyActiveCompanySubscription: any;
    private readonly currentlyActiveCompanySubscriptionSubject =
      new BehaviorSubject<CompanySubscription | undefined>(undefined);
    /** Emits the active company subscription and all subsequent changes. */
    readonly currentlyActiveCompanySubscription$ =
      this.currentlyActiveCompanySubscriptionSubject.asObservable();
    companySubscriptions: any[] = [];
    subscriptionPlans: any[] = [];
    userDetails: any;
    subscriptionTabsEnum = NS_SubscriptionService.subscriptionTabsEnum;
    subscriptionsActionRenderTypeEnum = NS_SubscriptionService.SubscriptionsActionRenderTypeEnum;
    statusListToFilterActiveCompanySubscription = NS_SubscriptionService.statusListToFilterActiveCompanySubscription;
    eventsSubject:Subject<NS_SubscriptionService.eventsSubjectData> = new Subject<NS_SubscriptionService.eventsSubjectData>();
    userLocation = '';
    products:Array<any> = [];
    productId = -1;
    noRetryForStatus = [NS_SubscriptionService.companySubscriptionStatusEnums.DOWNGRADE_SCHEDULED, NS_SubscriptionService.companySubscriptionStatusEnums.CANCELLATION_REQUESTED];
    productName: string = '';
    private allowedRoles = environment.ALLOWED_SUBSCRIPTION_ROLES;
    private authToken: any;
    private userRoles: any = [];
    private featureFlags: any;
    private _oldSubscription;
    private userPlanSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    public userPlan$: Observable<string | null> = this.userPlanSubject.asObservable();
    private get oldSubscription(){
      return this._oldSubscription;
    }
    private set oldSubscription(obj){
      this._oldSubscription = obj;
    }
    private get isOldActiveUser(){
      return get(this.oldSubscription,'status','') == "ENABLED" && !includes(["", "trial"], get(this.oldSubscription,'planId','')) &&  get(this.oldSubscription,'subscriptionPlanId') != 0 ;
    }
    private get isOldTrialUser(){
      return get(this.oldSubscription,'status','') == "ENABLED" && includes([ "trial"], get(this.oldSubscription,'planId','')) ;
    }
    private get isOldUser(){
      return this.companySubscriptions.length == 0 && (this.isOldActiveUser || this.isOldTrialUser);
    }
    private get isOldUserMigrated(){
      return get(this.oldSubscription,'userSubscriptionMigrated', false);
    }
    get isOldSubscriptionPlanEnterprise(){
      return this.isOldUser && includes(["enterprise", "enterprise_yearly"], get(this.oldSubscription,'planId',''))
    }
    private get canShowBannerBannerForOldUser(){
      return this.isEnforceMigrationCase || get(this.oldSubscription,'status','') == "ENABLED" && ( includes(["trial"], get(this.oldSubscription,'planId',''))  ) ;
    }

    get showMigrationFlowInPricingPage(){
      return this.isMigrationAnomaly || (this.isOldUser && this.isOldUserMigrated == false);
    }
    

    setOldSubscriptionFromHeaderComponent(obj){
      this._oldSubscription = obj;
    }

    get isEnforceMigrationCase(){
      return size(this.companySubscriptions) === 0 && (this.isOldActiveUser || this.isOldTrialUser) && this.oldSubscription.userSubscriptionMigrated === false && this.oldSubscription.enforceMigration === true
    }

    get newSubscriptionPlanMatchingOldSubscription() {
      return find( this.subscriptionPlans, (subscriptionPlan) => {
        return subscriptionPlan.subscriptionPlanGroup === "DEPRECATED" && subscriptionPlan.chargebeePlanId === this.oldSubscription.planId;
      })
    };

    get isTrialPresentInNewCompanySubscriptions(){
      return some(this.companySubscriptions, (companySub)=>{
        return includes(['Trial',  NS_SubscriptionService.trialSubscriptionPlanName], companySub?.subscriptionPlan?.name ) ;
      });
    }

    get hasNonTrialCompanySubscription(){
      return !isEmpty(this.companySubscriptions) && some(this.companySubscriptions, (companySub)=>{
        return !includes(['Trial',  NS_SubscriptionService.trialSubscriptionPlanName], companySub?.subscriptionPlan?.name );
      })
    }
    isCurrentlyActiveCompanySubscriptionNameTrial = false;
    
    private setCurrentlyActiveCompanySubscription(
      companySubscription: CompanySubscription | undefined
    ){
      this.currentlyActiveCompanySubscription = companySubscription;
      this.currentlyActiveCompanySubscriptionSubject.next(companySubscription);
      this.isCurrentlyActiveCompanySubscriptionNameTrial = includes(['Trial',  NS_SubscriptionService.trialSubscriptionPlanName], this.currentlyActiveCompanySubscription?.subscriptionPlan?.name );
      this.eventsSubject.next({eventKey: NS_SubscriptionService.eventSubjectDataEventKeyEnum.currentlyActiveCompanySubscription, eventValue: this.currentlyActiveCompanySubscription})
    }

    /**
     * Checks whether the current company subscription has the given add-on.
     * Missing subscription ids and request failures emit `hasAddon: false`.
     * @param addonName Add-on name to look up.
     * @returns Observable of add-on access for the current subscription.
     */
    hasActiveAddon$(
      addonName: NS_SubscriptionService.companySubscriptionAddonNameEnum
    ): Observable<ActiveAddonAccess> {
      return this.currentlyActiveCompanySubscription$.pipe(
        switchMap(subscription => {
          const companySubscriptionId = subscription?.id;
          if (isNil(companySubscriptionId)) {
            return of<ActiveAddonAccess>({ hasAddon: false });
          }
          return this.subscriptionDataService.companySubscriptionAddon
            .hasActiveAddon(companySubscriptionId, addonName)
            .pipe(
              map(hasAddon => ({ companySubscriptionId, hasAddon })),
              catchError(error => of<ActiveAddonAccess>({
                companySubscriptionId,
                error,
                hasAddon: false
              }))
            );
        })
      );
    }
    
    get isMigrationAnomaly(){
      return size(this.companySubscriptions) > 0 && (this.isOldActiveUser && this.isOldUserMigrated === false) ;
    }
    

    validate = {
      'ManageUsersComponent': {
        'addNewUserSubmit' : {
          isNewUser: ()=>{
            return this.isTrialPresentInNewCompanySubscriptions;
          },
          canAddUser: ()=>{
            return this.hasNonTrialCompanySubscription;
          }
        }
      },
      'DatawarehouseGridComponent':{
        userDataWarehouseLogin:{
          isNewUser: ()=>{
            return this.isTrialPresentInNewCompanySubscriptions;
          },
          canAddWareHouse: ()=>{
            return this.hasNonTrialCompanySubscription || !this.trialPlanService.isTrialPlanUsed;
          }
        }
      },
      'DatasourcesListingComponent': {
        'redirectToNewScreen':{
          'canSkipUserIntegrationLimit': ()=>{
            return this.isTrialPresentInNewCompanySubscriptions;
          }
        }
      },
      'IntegrationDetailsComponent': {
        'onChangeSourceStatus':{
          'canSkipUserIntegrationLimit': ()=>{
            return this.isTrialPresentInNewCompanySubscriptions;
          }
        }
      },
      'SubscriptionEventManagerComponent':{
        canShowBanner: (userRole)=>{
          return this.isTrialPresentInNewCompanySubscriptions || this.canShowBannerBannerForOldUser;
        }
      }
    }

    async initializeProduct(productName){
    this.productName = productName;
      this.subscriptionDataService.productName = productName;
      this.eventsSubject = new Subject<NS_SubscriptionService.eventsSubjectData>();
      await this.init();
      const plan = await this.getLatestSubscriptionPlan();
      this.userPlanSubject.next(plan);
    }
    private getProducts(productName){
      return new Observable((observer)=>{
        let products: Array<any> = this.cacheService.getObject(NS_Enums.cacheKeysEnum.products);
        let getProductId = (products)=>{
          return get(find(products, (product) => {
            return toLower(product.productName) === toLower(productName);
          }), ['id'], -1);
        }
        if(!isUndefined(products) && !isEmpty(products)){
          this.products = products;
          this.productId = getProductId(products);
          this.cacheService.putObject(NS_Enums.cacheKeysEnum.products, products, true);
          observer.next();
          observer.complete();
        } else {
          let x = this.subscriptionDataService.product.getProducts().subscribe((response: any) => {
            let products = get(response, ['data', 'content'], []);
            this.products = products;
            this.productId = getProductId(products);
            this.cacheService.putObject(NS_Enums.cacheKeysEnum.products, products, true);
            observer.next();
            observer.complete();
            x.unsubscribe();
          });
        }
      })     
    }

    private getOldSubscriptionPlan(){
      return new Observable((observer) => {
        this.appService.getCurrentSubscriptionPlan(this.userDetails?.userId).then((data)=>{
          if (data) {
            this.oldSubscription = data.body;
            this.eventsSubject.next({eventKey: NS_SubscriptionService.eventSubjectDataEventKeyEnum.oldSubscription, eventValue: this.oldSubscription});
            observer.next(data.body);
            observer.complete();
          }
        }).catch((error)=>{
          observer.error(error);
          observer.complete();
        });
      });
    }

    async init(refreshData = false) {
      await this.getProducts(this.productName).toPromise();
      const user: UserDetails = await this.getUserDetails().pipe(take(1)).toPromise();
      await this.getOldSubscriptionPlan().pipe(take(1)).toPromise();
    
      //FIXME: If we have to show banner for external users, we should init the trial plan service. hence commenting below if condition.
            //if (this.checkSubscriptionFeaturePersmission(user?.role)){
            //  console.log('this.trialPlanService.init() in subscription business service' );
      this.trialPlanService.init(this.eventsSubject, user, this.productName);
    
      this.getSubscriptionPlans(refreshData);
    }
    
    private getUserDetails(): Observable<UserDetails> {
      return new Observable<UserDetails>((observer)=>{
        this.appService.getUser().then((user) => {  
          this.userDetails = user;
          this.authToken = this.authService.authToken
          if(this.authToken) {
              this.userRoles = getRolesFromToken(this.authToken)
          }
          this.eventsSubject.next({eventKey: NS_SubscriptionService.eventSubjectDataEventKeyEnum.companyID, eventValue: get(user,'company.companyId')});
          observer.next(this.userDetails);
          observer.complete();
        });
      })
    }

    changeToNewSubscriptionPlan(subscriptionPlanId ){
      let newlySelectedPlan = find(this.subscriptionPlans, (plan) => {
        return plan.id == subscriptionPlanId;
      });

      if(this.isOldUser && this.isOldUserMigrated === false){
        // A) if value do not exist in new company  and exist in user_subcription and usermigrated false , then show migration flow. 
        //         1. check upgrade pr downgrade  by passing new subscriptionplanid if he is old user not migrated with matching subscriptionPlanGroup: "DEPRECATED" and chargebeePlanId === user_subscription.planId

        // pass subscriptionplanid for checkupgradedowngrade and estimate apis in that case.
        // upgrade flow starts, run utility and then upgrade.

        

        if(this.newSubscriptionPlanMatchingOldSubscription){
          let apiSubscription = this.subscriptionDataService.companySubscription.checkUpgradeDowngradeById(this.newSubscriptionPlanMatchingOldSubscription?.id , newlySelectedPlan?.id, this.oldSubscription?.cycleStartDate).subscribe((response: any) => {
            let responseMessage = get(response, ['data'],'');
            if( includes(responseMessage, "This is an upgrade scenario but the prorated bill needs to be 0 or more. So, cannot upgrade.")){
              this.handleErrorDontRedirect({statusText: responseMessage});
            } else if( includes(responseMessage, "This is an upgrade. Billing cycle stays the same, you get credit for unused time and pay only for the new plan’s remaining days")  ){
              if(isNil(newlySelectedPlan.chargebeePlanId)){
                this.handleErrorDontRedirect({statusText: 'No chargebee plan id found for this plan.'});
              } else if(!isEmpty(this.newSubscriptionPlanMatchingOldSubscription?.chargebeePlanId) ){
                this.updateSubscription({'action': NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.upgradeFromOldFlow, 'plan' : newlySelectedPlan}) 
              }            
            } else if(includes(responseMessage, "This is a downgrade scenario") ){
              this.updateSubscription({'action': NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.downgradeFromOldFlow, 'plan' : newlySelectedPlan}) 
            }
            apiSubscription.unsubscribe();
          },error => {
            this.handleErrorDontRedirect(error);
          });
        }


      } else {
        
        let currentPlanName = get(this.currentlyActiveCompanySubscription, 'subscriptionPlan.name');
        if(!isNil(currentPlanName) && (currentPlanName == NS_SubscriptionService.trialSubscriptionPlanName || this.currentlyActiveCompanySubscription?.status === NS_SubscriptionService.CANCELLED ) ){
          this.updateSubscription({'action': NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.choose, 'plan' : newlySelectedPlan})
        } else if(!isNil(this.currentlyActiveCompanySubscription?.subscriptionPlan?.id) && !isNil(newlySelectedPlan?.id) && !isNil(this.currentlyActiveCompanySubscription?.cycleStartDate) ){
          let apiSubscription = this.subscriptionDataService.companySubscription.checkUpgradeDowngradeById(this.currentlyActiveCompanySubscription?.subscriptionPlan?.id , newlySelectedPlan?.id, this.currentlyActiveCompanySubscription?.cycleStartDate).subscribe((response: any) => {
            let responseMessage = get(response, ['data'],'');
            if( includes(responseMessage, "This is an upgrade scenario but the prorated bill needs to be 0 or more. So, cannot upgrade.")){
              this.handleErrorDontRedirect({statusText: responseMessage});
            } else if( includes(responseMessage, "This is an upgrade. Billing cycle stays the same, you get credit for unused time and pay only for the new plan’s remaining days")  ){
              if(isNil(newlySelectedPlan.chargebeePlanId)){
                this.handleErrorDontRedirect({statusText: 'No chargebee plan id found for this plan.'});
              } else if(!isEmpty(this.currentlyActiveCompanySubscription.chargebeeSubscriptionId) ){
                this.updateSubscription({'action': NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.upgrade, 'plan' : newlySelectedPlan}) 
              }            
            } else if(includes(responseMessage, "This is a downgrade scenario") ){
              this.updateSubscription({'action': NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.downgrade, 'plan' : newlySelectedPlan}) 
            }
            apiSubscription.unsubscribe();
          },error => {
            this.handleErrorDontRedirect(error);
          });
        }
      }
    }
    
    updateSubscription(event: NS_SubscriptionPlanCard.onSubscriptionPlanCardSelectionEvent) {
        if (this.saras_auth_key) {
          if(event.action === NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.choose){
            if(!isNil(this.userDetails.userId) && !isNil(this.userDetails.company.companyId)){
              this.checkoutDataSubscription.subscriptionPlanId = event.plan.id;
              this.checkoutDataSubscription.userId = this.userDetails.userId;
              this.checkoutDataSubscription.companyId = this.userDetails.company.companyId;
              this.openCheckout();
            }
          } else if(event.action === NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.downgradeFromOldFlow){

            
            this.subscriptionDataService.chargebee.estimateDowngradeByPlanName(this.newSubscriptionPlanMatchingOldSubscription.name, event.plan.name).subscribe({
              next: (response: any) => {
                let self = this;
                const dialogRef = this.dialog.open(CommonDialogComponent, {
                  data: {
                    title: "Sure about the downgrade?",
                    content: `You are about to downgrade to ${event.plan.name}/${getBillingCycle(event.plan.billingDays, true )}`,
                    image: 'error',
                    buttons: [
                      {
                        'title': 'Proceed',
                        'meta': '',
                        'type': 'yes',
                        'class': 'confirm-dialog-proceed'
                      },
                      {
                        'title': 'Later',
                        'meta': '',
                        'type': 'no-change',
                        'class': 'confirm-dialog-later'
                      }
                    ]
                  },
                  disableClose: false,
                  scrollStrategy: new NoopScrollStrategy()
                });
                dialogRef.afterClosed().subscribe({
                  next: (result) => {
                    if (result?.type === 'yes') {
                      // run utility
                      self.subscriptionDataService.services.migrateSubscriptions().pipe(take(1)).subscribe({
                        next: (response) => {
                          let migratedCompanyIds = get(response, 'migratedCompanyIds');
                          if(size(migratedCompanyIds) > 0 ){
                            self.trialPlanService.checkUserSubscriptionMigratedAfterRunningUtility().pipe(take(1)).subscribe({
                              next: (isUserMigrated)=>{
                                self.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(this.userDetails?.company?.companyId).pipe(take(1)).subscribe({
                                  next: (response:any) => {
                                    if (response) {
                                      this.isLoadingCompanySubscriptions = false;
                                      // Process the successful response here
                                      let newCompanySubscriptions = this.getCompanySubscriptionsSortByIdDesc(response);
                                      this.setCompanySubscriptions(newCompanySubscriptions);
                                      self.subscriptionDataService.companySubscription.downgrade(self.currentlyActiveCompanySubscription.id, event.plan.id).subscribe({
                                        next: (response: any) => {
                                          if(get(response, ['data', 'status'], '') === NS_SubscriptionService.DOWNGRADE_SCHEDULED) {
                                            const dialogRef = this.dialog.open(CommonDialogComponent, {
                                              data: {
                                                title: 'Downgrade Successful',
                                                content: `Your Subscription Plan is scheduled to downgrade at the end of billing cycle (${formatDateCustom(self.currentlyActiveCompanySubscription.nextBillingDate)})`,
                                                image: 'successful',
                                                buttons: [
                                                  {
                                                    'title': 'Go to requests',
                                                    'meta': '',
                                                    'type': 'yes',
                                                    'class': 'confirm-dialog-proceed'
                                                  },
                                                  {
                                                    'title': 'Close',
                                                    'meta': '',
                                                    'type': 'no-change',
                                                    'class': 'confirm-dialog-later'
                                                  }
                                                ]
                                              },
                                              disableClose: false
                                            });
                                            dialogRef.afterClosed().subscribe({
                                              next: (result) => {
                                                if(result?.type === 'yes') {
                                                  this.router.navigateByUrl(`/${this.baseWord}/account/subscription/requests`);
                                                  this.refreshData();
                                                }
                                              }
                                            });
                                          }
                                        },
                                        error: (error)=>{
                                          this.handleError(error).catch(() => {});
                                        }
                                      });
                                    }
                                  },
                                  error: (error)=>{
                                    this.isLoadingCompanySubscriptions = false;
                                    console.error('getCompanySubscriptionByCompanyId failed', error);
                                    this.handleError(error).catch(() => {});
                                  }
                                })
                              },
                              error: (error) => {
                                console.error('User Migration failed downgradeFromOldFlow', error);
                              }
                            });
                          }
                        }
                      });
                    }
                  },
                  error: (error) => {
                    this.handleError(error).catch(() => {});
                  }
                });
              },
              error: (error) => {
                this.handleErrorDontRedirect(error).catch(() => {});
              }
            });
          }
          else if(event.action === NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.downgrade){
            this.subscriptionDataService.chargebee.estimateDowngradeByPlanName(this.currentlyActiveCompanySubscription.subscriptionPlan.name, event.plan.name).subscribe((response: any) => {
              let self = this;
              const dialogRef = this.dialog.open(CommonDialogComponent, {
                data: {
                  title: "Sure about the downgrade?",
                  content: `You are about to downgrade to ${event.plan.name}/${getBillingCycle(event.plan.billingDays, true )}`,
                  image: 'error',
                  buttons: [
                    {
                      'title': 'Proceed',
                      'meta': '',
                      'type': 'yes',
                      'class': 'confirm-dialog-proceed'
                    },
                    {
                      'title': 'Later',
                      'meta': '',
                      'type': 'no-change',
                      'class': 'confirm-dialog-later'
                    }
                  ]
                },
                disableClose: false,
                scrollStrategy: new NoopScrollStrategy()
              });
              dialogRef.afterClosed().subscribe(result => {
                if (result?.type === 'yes') {
                  self.subscriptionDataService.companySubscription.downgrade(self.currentlyActiveCompanySubscription.id, event.plan.id).subscribe((response: any) => {
                    if(get(response, ['data', 'status'], '') === NS_SubscriptionService.DOWNGRADE_SCHEDULED) {
                      const dialogRef = this.dialog.open(CommonDialogComponent, {
                        data: {
                          title: 'Downgrade Successful',
                          content: `Your Subscription Plan is scheduled to downgrade at the end of billing cycle (${formatDateCustom(self.currentlyActiveCompanySubscription.nextBillingDate)})`,
                          image: 'successful',
                          buttons: [
                            {
                              'title': 'Go to requests',
                              'meta': '',
                              'type': 'yes',
                              'class': 'confirm-dialog-proceed'
                            },
                            {
                              'title': 'Close',
                              'meta': '',
                              'type': 'no-change',
                              'class': 'confirm-dialog-later'
                            }
                          ]
                        },
                        disableClose: false
                      });
                      dialogRef.afterClosed().subscribe(result => {
                        if(result?.type === 'yes') {
                          this.router.navigateByUrl(`/${this.baseWord}/account/subscription/requests`);
                          this.refreshData();
                        }
                      });
                    }
                  }, (error)=>{
                    this.handleError(error).catch(() => {});
                  });
                }
              });
            });
          } else if(event.action === NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.upgradeFromOldFlow){


            let showConfirmationPopup = (response)=>{
              let self = this;
                const dialogRef = this.dialog.open(AccountCommonDialogComponent, {               //Pass data object as a second parameter  
                  panelClass: ['subscription-common-dialog'],
                  data: {  
                    type: NS_AccountCommonDialog.popupTypeEnum.upgradeEstimateConfirmation,
                    title: "You are upgrading to",
                    content: ``,
                    planName: event.plan.name,
                    planDescription: getFromDescription(event.plan.description, 'planName'),
                    billingDays: event.plan.billingDays,
                    paymentType: event.plan.paymentType,
                    estimatedCost: response,
                    buttons: [
                      {
                        'title': 'Cancel',
                        'meta': '',
                        'type': NS_AccountCommonDialog.dialogResultTypeEnum.cancel,
                        'class': 'confirm-subscription-dialog-close secondary-button'
                      },
                      {
                        'title': 'Confirm Upgrade',
                        'meta': '',
                        'type': NS_AccountCommonDialog.dialogResultTypeEnum.ok,
                        'class': 'confirm-subscription-dialog-proceed'
                      }
                    ],
                  },  
                  disableClose: false,
                });
                dialogRef.afterClosed().subscribe(result => {
                  if (result === NS_AccountCommonDialog.dialogResultTypeEnum.ok) {

                    self.subscriptionDataService.services.migrateSubscriptions().pipe(take(1)).subscribe(response => {
                      let migratedCompanyIds = get(response, 'migratedCompanyIds');
                      if(size(migratedCompanyIds) > 0 ){
                        self.trialPlanService.checkUserSubscriptionMigratedAfterRunningUtility().pipe(take(1)).subscribe({
                          next: (isUserMigrated)=>{
                            this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(this.userDetails?.company?.companyId).pipe(take(1)).subscribe({
                              next: (response:any) => {
                              if (response) {
                                this.isLoadingCompanySubscriptions = false;
                                // Process the successful response here
                                let newCompanySubscriptions = this.getCompanySubscriptionsSortByIdDesc(response);
                                this.setCompanySubscriptions(newCompanySubscriptions);

                                let forceTermReset = false;
                                if(self.currentlyActiveCompanySubscription.subscriptionPlan.billingDays != event.plan.billingDays  ) {
                                  forceTermReset = true;
                                } else if(self.currentlyActiveCompanySubscription.subscriptionPlan.billingDays == event.plan.billingDays){
                                  forceTermReset = false;
                                }

                                self.subscriptionDataService.companySubscription.upgrade(self.currentlyActiveCompanySubscription.id, event.plan.id, forceTermReset).subscribe({
                                  next: (response: any) => {
                                  if(get(response, ['data', 'status'], '') === NS_SubscriptionService.UPGRADED) {
                                    const dialogRef = this.dialog.open(CommonDialogComponent, {
                                      data: {
                                        title: 'Upgrade Successful',
                                        content: `You have successfully upgraded to ${event.plan.name} plan`,
                                        image: 'successful',
                                        buttons: [
                                          {
                                            'title': 'Go to requests',
                                            'meta': '',
                                            'type': 'yes',
                                            'class': 'confirm-dialog-proceed'
                                          },
                                          {
                                            'title': 'Close',
                                            'meta': '',
                                            'type': 'no-change',
                                            'class': 'confirm-dialog-later'
                                          }
                                        ]
                                      },
                                      disableClose: false
                                    });
                                    dialogRef.afterClosed().subscribe(result => {
                                      if(result?.type === 'yes') {
                                        this.router.navigateByUrl(`/${this.baseWord}/account/subscription/requests`);
                                        this.refreshData();
                                      }
                                    });
                                  }
                                  },
                                  error: (error)=>{
                                    this.handleError(error).catch(() => {});
                                  }
                                });
                              }
                              },
                              error: (error)=>{
                                this.isLoadingCompanySubscriptions = false;
                                console.error('getCompanySubscriptionByCompanyId failed', error);
                                this.handleError(error).catch(() => {});
                              }
                            })
                          },
                          error: (error) => {
                            console.error('User Migration failed upgradeFromOldFlow', error);
                          }
                        })
                      }
                    })
                  }
                });
            }

            this.subscriptionDataService.chargebee.estimateUpgradeByPlanName(this.oldSubscription.chargeBeeSubscriptionId, event.plan.chargebeePlanId).subscribe((response: any) => {
              showConfirmationPopup(response);
            }, (error) => {
              // FIXME: showConfirmationPopup(error); was called for demo flow, but estimateUpgradeByPlanName api is throwing error. So added handleErrorDontRedirect(error) to show the message.
              // To perform this operation, the current term's invoice [draft_inv_AzqD4iTsMtNGD28ir] needs to be closed.
              //showConfirmationPopup(error);
              this.handleErrorDontRedirect(error);
            });
          } else if(event.action === NS_SubscriptionPlanCard.subscriptionPlanActionsEnum.upgrade){
            let showConfirmationPopup = (response)=>{
              let self = this;
                const dialogRef = this.dialog.open(AccountCommonDialogComponent, {               //Pass data object as a second parameter  
                  panelClass: ['subscription-common-dialog'],
                  data: {  
                    type: NS_AccountCommonDialog.popupTypeEnum.upgradeEstimateConfirmation,
                    title: "You are upgrading to",
                    content: ``,
                    planName: event.plan.name,
                    planDescription: getFromDescription(event.plan.description, 'planName'),
                    billingDays: event.plan.billingDays,
                    paymentType: event.plan.paymentType,
                    estimatedCost: response,
                    buttons: [
                      {
                        'title': 'Cancel',
                        'meta': '',
                        'type': NS_AccountCommonDialog.dialogResultTypeEnum.cancel,
                        'class': 'confirm-subscription-dialog-close secondary-button'
                      },
                      {
                        'title': 'Confirm Upgrade',
                        'meta': '',
                        'type': NS_AccountCommonDialog.dialogResultTypeEnum.ok,
                        'class': 'confirm-subscription-dialog-proceed'
                      }
                    ],
                  },  
                  disableClose: false,
                });
                dialogRef.afterClosed().subscribe(result => {
                  if (result === NS_AccountCommonDialog.dialogResultTypeEnum.ok) {
                    let forceTermReset = false;
                    if(self.currentlyActiveCompanySubscription.subscriptionPlan.billingDays != event.plan.billingDays && self.currentlyActiveCompanySubscription.subscriptionPlan.subscriptionPlanIdentifier == event.plan.subscriptionPlanIdentifier ) {
                      forceTermReset = true;
                    } else if(self.currentlyActiveCompanySubscription.subscriptionPlan.billingDays == event.plan.billingDays && self.currentlyActiveCompanySubscription.subscriptionPlan.subscriptionPlanIdentifier != event.plan.subscriptionPlanIdentifier ){
                      forceTermReset = false;
                    }
                    
                    self.subscriptionDataService.companySubscription.upgrade(self.currentlyActiveCompanySubscription.id, event.plan.id, forceTermReset).subscribe((response: any) => {
                      if(get(response, ['data', 'status'], '') === NS_SubscriptionService.UPGRADED) {
                        const dialogRef = this.dialog.open(CommonDialogComponent, {
                          data: {
                            title: 'Upgrade Successful',
                            content: `You have successfully upgraded to ${event.plan.name} plan`,
                            image: 'successful',
                            buttons: [
                              {
                                'title': 'Go to requests',
                                'meta': '',
                                'type': 'yes',
                                'class': 'confirm-dialog-proceed'
                              },
                              {
                                'title': 'Close',
                                'meta': '',
                                'type': 'no-change',
                                'class': 'confirm-dialog-later'
                              }
                            ]
                          },
                          disableClose: false
                        });
                        dialogRef.afterClosed().subscribe(result => {
                          if(result?.type === 'yes') {
                            this.router.navigateByUrl(`/${this.baseWord}/account/subscription/requests`);
                            this.refreshData();
                          }
                        });
                      }
                    }, (error)=>{
                      this.handleError(error).catch(() => {});
                    });
                  }
                });
            }

            this.subscriptionDataService.chargebee.estimateUpgradeByPlanName(this.currentlyActiveCompanySubscription.chargebeeSubscriptionId, event.plan.chargebeePlanId).subscribe((response: any) => {
              showConfirmationPopup(response);
            }, (error) => {
              // FIXME: showConfirmationPopup(error); was called for demo flow, but estimateUpgradeByPlanName api is throwing error. So added handleErrorDontRedirect(error) to show the message.
              // To perform this operation, the current term's invoice [draft_inv_AzqD4iTsMtNGD28ir] needs to be closed.
              //showConfirmationPopup(error);
              this.handleErrorDontRedirect(error);
            });
          }
        } else {
          this.router.navigate(['/' + this.uncommonBaseWord + '/login'], { queryParams: { routeTo: this.router.url } });
        }
    }

    handleError(
      error: any,
      redirect = true
    ): Promise<any> {
      this.openErrorDialog(error, redirect);
      return Promise.reject(error.message || error);
    }
  
    handleErrorDontRedirect(error: any): Promise<any> {
      this.openErrorDialog(error, false);
      return Promise.reject(error);
    }

    private openErrorDialog(error: any, redirect: boolean) {
      let errorMessage;
      let documentURL:string;
      let documentName:string;
      try {
        if( isJsonValid (get(error,['error','errors',0, 'message'], '')) ){
          let errorObject = JSON.parse(error.error.errors[0].message);
          errorMessage = get(errorObject, ['message'], 'OK');
        } else {
          errorMessage = error.error.errors[0].message;
        }
      } catch (e) {
        errorMessage = error.statusText;
      }

      if(includes(errorMessage, 'No changes are scheduled for this subscription.') ){
        errorMessage = 'No changes are scheduled for this subscription.';
      }

      if (errorMessage === 'Forbidden' || errorMessage === 'Token is not valid') {
        errorMessage = 'Token is not valid. logging out..';
      }
  
      if(error === 'Contact Support' || error === 'Subscribe for payment information'){
        errorMessage = error;
      }
      if(errorMessage == 'OK') {
        errorMessage = 'Oops! Something went wrong'
      }
      if(errorMessage == 'Unknown Error') {
        errorMessage = 'Server Not Responding.'
      }

      // if(errorMessage == "This is an upgrade scenario but the prorated bill needs to be 0 or more. So, cannot upgrade." || includes(errorMessage, "To perform this operation, the current term's invoice")){
      //   errorMessage = 'Upgrade failed. Please retry or contact support'
      // }
      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: 'Alert!',
          content: errorMessage,
          documentURL: documentURL,
          documentName: documentName,
          image: 'error',
          buttons: [
            {
              title: 'OK',
              meta: '/integrations-list',
              type: 'no-change',
              class: 'confirm-dialog-later',
            },
          ],
        },
        disableClose: true,
        scrollStrategy: new NoopScrollStrategy(),
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (errorMessage === 'Token is not valid. logging out..') {
          this.cacheService.clear();
          
          if (redirect) {
            this.router.navigate(['/']).then();
          }
        }
        if(errorMessage === 'Subscribe for payment information'){
          
        }
        if(errorMessage === 'Not Allowed') {
          this.router.navigate(['/']);
        }
      });
    }
    
    private openCheckout() {
      this.appService.openCheckoutSafely({
        hostedPage: (data) => {
          console.log('hostedPage', data);
          return this.subscriptionDataService.chargebee.getHostPageURL(this.checkoutDataSubscription).toPromise();
        },
        loaded: (data) => {
          // checkout is loaded
        },
        error: (data) => {
          console.error('Chargebee checkout error:', data);
        },
        close: (data) => {
          // this.loading = false;
          console.log('close', data);
        },
        success: (hostedPageId) => {
          console.log('success', hostedPageId);
          this.trialPlanService.endTrialCompanySubscriptionIfApplicable();
          this.eventsSubject.next({eventKey: NS_SubscriptionService.eventSubjectDataEventKeyEnum.subscriptionPaymentSuccess, eventValue: []});
          this.refreshData();
        },
        step: (value) => {
          // value -> which step in checkout
        }
      });
    }

    destroy(){
      this.subscriptionDataService.clearSubscriptionServiceMapData();
      this.setCurrentlyActiveCompanySubscription(undefined);
      this.userDetails = undefined;
      this.oldSubscription = {};
      this.subscriptionPlans = [];
      this.companySubscriptions = [];
      this.authToken = undefined;
      this.userRoles = [];
      this.eventsSubject.next({eventKey: NS_SubscriptionService.eventSubjectDataEventKeyEnum.currentlyActiveCompanySubscription, eventValue: this.currentlyActiveCompanySubscription});
      this.eventsSubject.complete();
    }

    refreshData() {
      this.subscriptionDataService.clearSubscriptionServiceMapData();
      this.init(true);
    }
    
    getSubscriptionPlans(refreshData = false) {
      this.subscriptionDataService.subscriptionPlan.getSubscriptionPlans(this.productId).subscribe({
        next : (plans: any) => {
          this.subscriptionPlans = plans;
          console.log('getDatonSubscriptionPlans', this.subscriptionPlans);
          this.eventsSubject.next({eventKey: NS_SubscriptionService.eventSubjectDataEventKeyEnum.subscriptionPlans, eventValue: this.subscriptionPlans});
        }
      });
      if(refreshData){
        this.fetchCompanySubscriptionsWithRetry();
      }
    }

    capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }

    private getCurrentCompanySubscriptionPlan() {
        this.subscriptionDataService.companySubscription.getCompanySubscriptionById(this.currentlyActiveCompanySubscription.id).subscribe({
            next: (response:any) => {
                if (!isUndefined(response.data) ) {
                    
                }
            }
        });
    }

    openBillingCycleChangePopUp() {
        const dialogRef = this.dialog.open(BillingCycleChangeComponent, {               //Pass data object as a second parameter  
            data: {  
                type: 'large-dialog',
                title: "Choose your preffered billing cyle:",
                billedBox: [
                    {
                    'title': '$100 Billed Monthly',
                    'meta': '',
                    'type': 'large-dialog',
                    'class': 'left-billed-btn'
                    },
                    {
                    'title': '$1000 Billed anually',
                    'meta': '',
                    'type': 'large-dialog',
                    'class': 'right-billed-btn'
                    }
                ],
                buttons: {
                'title': 'Submit Request',
                'meta': '',
                'type': 'large-dialog',
                'class': 'billed-box-btn'
                },
                content: "Looking for a billing cycle that meets your needs?",
                points: [
                {
                    'title': 'Quaterly Billing',
                },
                {
                    'title': 'Bi - annual Billing',
                },
                {
                    'title': 'Custom plan',
                },
                {
                    'title': 'Any Billing or customer support',
                },
                ],
                contactBtn:
                {
                'title': 'Contact Customer support',
                'meta': '',
                'type': 'large-dialog',
                'class': 'billed-box-btn'
                },
                subscriptionPlans: this.subscriptionPlans,
                currentlyActiveCompanySubscription: this.currentlyActiveCompanySubscription
            },  
            disableClose: true,
        }); 
        dialogRef.afterClosed().subscribe(result => {
            if(result != 'cancel'){
              this.changeToNewSubscriptionPlan(result);
            }
        });
    }

    private isCancellationSurveyActive = false;

    onCancelCompanySubscription(companySubscription) {
        let self = this;

        this.subscriptionDataService.chargebee.estimateCancellationByCurrentSubscriptionPlanId(this.currentlyActiveCompanySubscription.id).subscribe((response: any) => {
          if( !isUndefined(response) ) {
            //0
            const dialogRef = this.dialog.open(CommonDialogComponent, {
              data: {
                title: 'Sure about the cancellation?',
                content: `Your are about to cancel your Daton subscription plan.`,
                image: 'error',
                buttons: [
                  {
                    'title': 'Proceed',
                    'meta': '',
                    'type': 'yes',
                    'class': 'confirm-dialog-proceed'
                  },
                  {
                    'title': 'Later',
                    'meta': '',
                    'type': 'no-change',
                    'class': 'confirm-dialog-later'
                  }
                ]
              },
              disableClose: false
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result?.type === 'yes') {
                self.interceptCancellation();
              }
            });
          }
        });
    }

    private cancellationSurveyTimeoutMs = 60000;

    interceptCancellation(): void {
        if (this.isCancellationSurveyActive) return;

        if (!window.productFruits?.api?.surveys?.startSurvey) {
            this.executeCancellation();
            return;
        }

        this.isCancellationSurveyActive = true;

        let surveyTimeoutId: number;

        const cleanup = () => {
            window.removeEventListener('productfruits:survey:completed', onSurveyEnd);
            window.removeEventListener('productfruits:survey:dismissed', onSurveyEnd);
            clearTimeout(surveyTimeoutId);
        };

        const onSurveyEnd = () => {
            if (!this.isCancellationSurveyActive) return;
            cleanup();
            this.isCancellationSurveyActive = false;
            this.executeCancellation();
        };

        try {
            window.addEventListener('productfruits:survey:completed', onSurveyEnd, { once: true });
            window.addEventListener('productfruits:survey:dismissed', onSurveyEnd, { once: true });

            surveyTimeoutId = window.setTimeout(() => {
                onSurveyEnd();
            }, this.cancellationSurveyTimeoutMs);

            window.productFruits.api.surveys.startSurvey(environment.pfCancellationSurveyId);
        } catch (e) {
            cleanup();
            this.isCancellationSurveyActive = false;
            this.executeCancellation();
        }
    }

    private executeCancellation(): void {
        let self = this;
        self.subscriptionDataService.companySubscription.cancel(self.currentlyActiveCompanySubscription.id).subscribe((response: any) => {
            if(get(response, ['data', 'status'], '') === NS_SubscriptionService.CANCELLATION_REQUESTED) {
                const dialogRef = this.dialog.open(CommonDialogComponent, {
                    data: {
                        title: 'Request Successful',
                        content: `Your Subscription Plan is scheduled to cancel at the end of billing cycle (${formatDateCustom(self.currentlyActiveCompanySubscription.nextBillingDate)})`,
                        image: 'alert',
                        buttons: [
                            {
                                'title': 'Go to requests',
                                'meta': '',
                                'type': 'yes',
                                'class': 'confirm-dialog-proceed'
                            },
                            {
                                'title': 'Later',
                                'meta': '',
                                'type': 'no-change',
                                'class': 'confirm-dialog-later'
                            }
                        ]
                    },
                    disableClose: false
                });
                dialogRef.afterClosed().subscribe((result) => {
                    if (result?.type === 'yes') {
                        this.router.navigateByUrl(`/${this.baseWord}/account/subscription/requests`);
                        this.refreshData();
                    }
                });
            }
        }, (error) => {
            this.handleError(error).catch(() => {});
        });
    }

    getAllBillingAddressForCompany(){
      return new Observable((observer) => {
        if(isNil(this.currentlyActiveCompanySubscription?.subscriptionPlan?.id) || isNil(this.userDetails?.company?.companyId)){
          observer.error('no active subscription plan');
          observer.complete();
        } else{
          this.subscriptionDataService.chargebee.getAllBillingAddressByCompanyId(this.userDetails?.company?.companyId, this.currentlyActiveCompanySubscription?.subscriptionPlan?.id).subscribe((billingAddressObject:any) => {
            this.updateUserLocation(billingAddressObject);
            observer.next(billingAddressObject);
            observer.complete();
          });
        }
        
      });
        
    }

    private updateUserLocation(billingAddressObject){
      let city = get(billingAddressObject, ['city'], 'NA');
      let country = get(billingAddressObject, ['country'], '');
      this.userLocation = `${city}${country != '' ? `, ${country}` : ''}`;
    }

    cancelCompanySubscriptionRequest(companySubscriptionId){
      this.subscriptionDataService.companySubscription.cancelRequest(companySubscriptionId).subscribe((response:any) => {
        if(includes(get(response, ['data'], ''), 'request cancelled successfully')  ){
          this.snackBar.open(
            get(response, ['data'], ''), '',
            {duration: 2500, verticalPosition: 'top',horizontalPosition: 'center', panelClass: ['reload-snack-bar']});
          this.getSubscriptionPlans();
          this.fetchCompanySubscriptionsWithRetry()
        }
      }, (error)=>{
        this.handleError(error).catch(() => {});
      });
    }

    isLoadingCompanySubscriptions = false;
    currentRetryAttemptForCompanySubscription = 1;
    continueFetchDataWithRetry = false;
    fetchCompanySubscriptionsWithRetry(): void {

      let currentCompanySubscriptions = this.getCompanySubscriptionsSortByIdDesc();
      const maxRetries = 5; // Maximum number of retry attempts
      let isCompanySubscriptionsChanged = false;
      this.currentRetryAttemptForCompanySubscription = 1;
      this.continueFetchDataWithRetry = true;
      
      let stopFetchDataWithRetry = ()=>{
        this.currentRetryAttemptForCompanySubscription = 1;
        isCompanySubscriptionsChanged = false;
        this.continueFetchDataWithRetry = false;
        this.isLoadingCompanySubscriptions = false;
      }

      
      
      let apiCall = () => {
        this.isLoadingCompanySubscriptions = true;
        this.subscriptionDataService.companySubscription.getCompanySubscriptionByCompanyId(this.userDetails?.company?.companyId)
        .pipe(take(1)).subscribe({
          next: (response:any) => {
            if (response) {
              this.isLoadingCompanySubscriptions = false;
              // Process the successful response here
              let newCompanySubscriptions = this.getCompanySubscriptionsSortByIdDesc(response);
              if (this.compareSubscriptionPlans(newCompanySubscriptions, currentCompanySubscriptions)) {
                isCompanySubscriptionsChanged = size(currentCompanySubscriptions) === size(newCompanySubscriptions) && this.checkForStatus(get(first(newCompanySubscriptions), 'status', ''), get(first(currentCompanySubscriptions), 'status', '')) ? false : true;
                this.setCompanySubscriptions(newCompanySubscriptions);
              }
              if(!isCompanySubscriptionsChanged && this.currentRetryAttemptForCompanySubscription < maxRetries && this.continueFetchDataWithRetry){
                this.currentRetryAttemptForCompanySubscription++;
                of(this.currentRetryAttemptForCompanySubscription).pipe(delay(this.currentRetryAttemptForCompanySubscription * 2000)).subscribe((results) => {
                  apiCall();
                });
              } else {
                stopFetchDataWithRetry();
                if (!isUndefined(this.currentlyActiveCompanySubscription)) {
                  this.eventsSubject.next({eventKey: NS_SubscriptionService.eventSubjectDataEventKeyEnum.currentlyActiveCompanySubscription, eventValue: this.currentlyActiveCompanySubscription})
                }
              }
            } else {
              // Handle errors if needed
            }
          },
          error: (error) => {
            // Stop the retry loop and clear the spinner, else the user is stuck mid-flight.
            stopFetchDataWithRetry();
            console.error('getCompanySubscriptionByCompanyId failed', error);
            this.handleError(error).catch(() => {});
          }
        });
      }
      
      apiCall();
      
    }

    compareSubscriptionPlans(incomingSubscription: CompanySubscription[], currentCompanySubscription: CompanySubscription[]): boolean {
      if(size(incomingSubscription) !== size(currentCompanySubscription)) {
        return true;
      }
      else if(get(first(incomingSubscription), 'targetSubscriptionPlan') && !get(first(currentCompanySubscription), 'targetSubscriptionPlan')) {
        return true;
      }
      else if(get(first(incomingSubscription), 'status') !== get(first(currentCompanySubscription), 'status')) {
        return true;
      }
      return false;
    }
  
    checkForStatus(newStatus: string, currentStatus: string): boolean {
      if(includes(this.noRetryForStatus, newStatus) || includes(this.noRetryForStatus, currentStatus)) {
        return false;
      } 
      return true;
    }

    setCompanySubscriptions(companySubscriptions){
      this.companySubscriptions = this.getCompanySubscriptionsSortByIdDesc(companySubscriptions);
      console.log(`getCompanySubscriptions attempt${this.currentRetryAttemptForCompanySubscription}`, companySubscriptions);
      if(companySubscriptions.length > 0){
        let latestCompSub:any = head(this.companySubscriptions);
        // if(latestCompSub.status == NS_SubscriptionService.SUSPENDED ){
        //   this.trialPlanService.doWhenCompanySusbcriptionIsSuspended(latestCompSub);
        // }
        if(this.trialPlanService.checkIfTrialPlanCompanySubscriptionActive(latestCompSub) || includes(NS_SubscriptionService.statusListToFilterActiveCompanySubscription, latestCompSub.status)){
          if(latestCompSub.status == NS_SubscriptionService.UPGRADED && !isNil(latestCompSub.targetSubscriptionPlan)){
            // When a plan is upgraded and before the new plan becomes ACTIVE in company subscription it will be stay in UPGRADED state.
            // During UPGRADED status show targetSubscriptionPlan details because that will become active. 
            
            latestCompSub.subscriptionPlan = latestCompSub.targetSubscriptionPlan;
          }
          this.setCurrentlyActiveCompanySubscription(latestCompSub)
        } else {
          this.setCurrentlyActiveCompanySubscription(undefined);
        }                
      } else {
        this.setCurrentlyActiveCompanySubscription(undefined);
      }
      
    }

    getCompanySubscriptionsSortByUpdatedDesc(companySubscriptions = undefined ):any{
      // return company subscriptions in descending order of updated date
      const x = companySubscriptions != undefined ? companySubscriptions : this.companySubscriptions;
      let arr:any = JSON.parse(JSON.stringify(x));
      return arr.sort((a, b) => {
        return new Date(b.updated).getTime() - new Date(a.updated).getTime();
      });
    }

    getCompanySubscriptionsSortByIdDesc(companySubscriptions = undefined ):any{

      const x = companySubscriptions != undefined ? companySubscriptions : this.companySubscriptions;
      // return company subscriptions in descending order of updated date
      let arr:any = JSON.parse(JSON.stringify(x));
      return orderBy(arr, ['id'], ['desc'])
    }

    updateBillingAddress(billingAddress: UpdateBillingAddress){
      return new Observable((observer) => {
        if(isNil(this.currentlyActiveCompanySubscription?.subscriptionPlan?.id) || isNil(this.userDetails?.company?.companyId)){
          observer.error('no active subscription plan');
          observer.complete();
        } else{
          this.subscriptionDataService.chargebee.updateBillingAddressByCompanyId(this.userDetails?.company?.companyId, this.currentlyActiveCompanySubscription?.subscriptionPlan?.id, billingAddress).subscribe((billingAddressObject:any) => {   
            observer.next('success');
            observer.complete();
          }, (error)=>{
            observer.error(error);
            observer.complete();
          });
        }
      });
    }

    goToContactUs(){
      window.open('https://sarasanalytics.com/contact/', "_blank")
    }
    talkToCustomerSupport(){
      window.open(customerSupportLink, "_blank");
    }

    onContactAdminForPlanChange(){
      if (this.userDetails.createdBy != 0) {
        this.appService.getAdminEmail(this.userDetails.createdBy).then((response) => {
          let adminEmail = response
          const dialogRef = this.dialog.open(CommonDialogComponent, {
            data: {
              title: 'Unauthorized',
              content: 'Only admin users can request a plan upgrade. Please contact your admin at '+ adminEmail,
              image: 'alert',
              buttons: [
                {
                  'title': 'OK',
                  'meta': '/datasources-listing',
                  'type': 'redirect',
                  'class': 'confirm-dialog-later'
                }
              ]
            },
            disableClose: true,
            scrollStrategy: new NoopScrollStrategy()
          });
          //this.trialPlanUsed = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result?.type === 'redirect') {
             // this.router.navigate(['/' + this.baseWord + '/datasources-listing']);
            }
          });

        }).catch((err) => {
          this.appService.handleError(err);
        });
      }
    }

    checkSubscriptionFeaturePersmission = (role?) => {
      let email = '';
      if(this.userDetails?.email){
        email = this.userDetails?.email;
      } else {
        const user_details = this.cacheService.getObject<any>(NS_Enums.cacheKeysEnum.user_details);
        email =  user_details?.email;
      }
      
      //TODO Subscription phase 2 all new users
      if( this.isTrialPresentInNewCompanySubscriptions ){
        
        let featureFlagRules;
        let roleRules;
        if(this.featureFlags) {
            //TODO: Will be implemented once rbac comes
        }
    
        if(!isEmpty(compact(this.userRoles))) {
          roleRules = operators['roleIntersection'](this.allowedRoles)
        } else if(isEmpty(this.userRoles) && !isEmpty(role)) {
          this.userRoles = castArray(role)
          roleRules = operators['roleIntersection'](this.allowedRoles)
        }
        const composedRule = roleRules;
        const flag = jsonDSL.apply(composedRule, {
          role: this.userRoles
        }) 
        return flag
      } else {
        return false;
      }  
    }

    checkOldSubscriptionFeaturePersmission = (role?) => {
      return !this.checkSubscriptionFeaturePersmission(role);
    }

    checkNewSubscriptionModifyPersmission = (role?) => {
      let email = '';
      if(this.userDetails?.email){
        email = this.userDetails?.email;
      } else {
        const user_details = this.cacheService.getObject<any>(NS_Enums.cacheKeysEnum.user_details);
        email =  user_details?.email;
      }
      //TODO Subscription phase 2 all new users
      if( this.isTrialPresentInNewCompanySubscriptions ){
        let featureFlagRules;
        let roleRules;
        if(this.featureFlags) {
            //TODO: Will be implemented once rbac comes
        }

        let allowedRoles = difference(this.allowedRoles, ['OrganizationUser']) 
    
        if(!isEmpty(compact(this.userRoles))) {
          roleRules = operators['roleIntersection'](allowedRoles)
        } else if(isEmpty(this.userRoles) && !isEmpty(role)) {
          this.userRoles = castArray(role)
          roleRules = operators['roleIntersection'](allowedRoles)
        }
        const composedRule = roleRules;
        const flag = jsonDSL.apply(composedRule, {
          role: this.userRoles
        }) 
        return flag
      } else {
        return false;
      }  
    }
  
    public async getLatestSubscriptionPlan() {
      try {
          if (!this.userDetails?.company?.companyId) return;
          const url = `${environment.subscriptionApiUrl}/company-subscription/${this.userDetails.company.companyId}/latest`;
          const response: any = await this.http.get(url).toPromise();
          
          if (Array.isArray(response?.data)) {
              const datonSubscription = find(response?.data, sub => 
                  toLower(get(sub, 'subscriptionPlan.product.productName')) === this.productName
              );
              if (datonSubscription) {
                  const rawPlan = get(datonSubscription, 'subscriptionPlan.subscriptionPlanGroup', 'TRIAL');
                  const normalizedPlan = this.appService.normalizePlan(rawPlan);
                  return normalizedPlan;
              }
          }
      } catch (error) {
          console.error('Error fetching subscription plan:', error);
          throw error;
      }
  } 

}
